module.exports = __webpack_public_path__ + "img/albumArtPlaceHolder.85fe9163.svg";